import { ENV } from '../envVars'
import { Channel } from '../types'

export const getEnvVars = () => {
  const easBuildProfile = process.env.EAS_BUILD_PROFILE
  const envKeyFromLocalOrNative =
    easBuildProfile || (__DEV__ ? Channel.DEVELOPMENT : Channel.PRODUCTION)
  return ENV[envKeyFromLocalOrNative]
}
